<canvas baseChart [data]="barChartData" [options]="barChartOptions" [type]="'bar'"> </canvas>
